const redirectAcesso = ({ next, router, to, store }) => {
  const responsavelFinanceiro = store.state.rematricula.responsavelFinanceiro;
  if (responsavelFinanceiro) {
    const service = new CodigoService(this.$http);
    return service.getUltimoCodigo(responsavelFinanceiro.id).then(response => {
      let path = "/rematricula/acesso";

      if (response.id !== undefined) {
        let codigoAcesso = "";

        if (this.$route.params.codigoAcesso) {
          codigoAcesso = this.$route.params.codigoAcesso;
        }

        return router.push(`${path}/validacao/${codigoAcesso}`);
      } else {
        return router.push(`${path}/solicitacao`);
      }
    });
  } else {
    return router.push("/rematricula/login");
  }

  return next();
};

export default redirectAcesso;



// WEBPACK FOOTER //
// ./src/middleware/rematricula/redirectAcesso.js